export {
  default as LoopingCarousel,
  type SlideTrackingEvents as LoopingCarouselSlideTrackingEvents,
} from './looping-carousel/looping-carousel'
